import React from 'react';
import { fmt } from '../../utils/fmtUtils';

const TablaVotosPartidos_FilaCandidatoVotos = props => {
  return (
    <>
      <td className="votes margin">{fmt(props.data.vot)}</td>
      <td className="percent">{props.data.pvot}</td>
    </>
  );
};

export default TablaVotosPartidos_FilaCandidatoVotos;
